// extracted by mini-css-extract-plugin
module.exports = {"ctas":"CapsuleBannerCtas_ctas__NFvpT","column":"CapsuleBannerCtas_column__i0049","cta":"CapsuleBannerCtas_cta__8ZUOt","hidden":"CapsuleBannerCtas_hidden__FPvPH"};